import type { Environment } from './environment.interface';

/**
 * Environment for production builds
 */
export const ENVIRONMENT: Environment = {
  production: true,
  test: false
};
